// extracted by mini-css-extract-plugin
export default {"cls1":"buttonStyles-cls1_tti","cls2":"buttonStyles-cls2_ufW buttonStyles-cls1_tti"};